export default __webpack_public_path__ + "static/media/work1.fa34af2d.jpg";